import ProfileMyPlaylists from './ProfileMyPlaylists'

export default ProfileMyPlaylists
